export const SEARCH_TYPE_OPTIONS = [
  { label: "Service name", value: 1 },
  { label: "Service ID", value: 2 },
  { label: "Category name", value: 4 },
  { label: "Category ID", value: 5 },
];
